module.exports = __webpack_public_path__ + "static/media/btnright.981d9363.png";